import axios from "./config";

export default {
  getNavAidById: (id: number) =>
    axios.request({
      method: "get",
      url: `/api/v1/navigational_aids/${id}`,
    }),
};
